import { render, staticRenderFns } from "./TourKiosk.vue?vue&type=template&id=1e4c4a45&scoped=true&"
import script from "./TourKiosk.vue?vue&type=script&lang=ts&"
export * from "./TourKiosk.vue?vue&type=script&lang=ts&"
import style0 from "./TourKiosk.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./TourKiosk.vue?vue&type=style&index=1&id=1e4c4a45&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4c4a45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VAppBar,VContainer,VMain,VSpacer})
